<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span [routerLink]="['/user-management/permission/list']" class="go-back">
      <img src="assets/images/arrow-left.svg" alt="arrow-left" />Permissions
      List
    </span>
    <img src="assets/images/arrow-right.svg" alt="arrow-right" />
    <ng-container *ngIf="!isEdit">Add</ng-container>
    <ng-container *ngIf="isEdit">Edit</ng-container> Permission
  </div>
  <form
    class="mat-form"
    [formGroup]="upsertPermissionFrom"
    (ngSubmit)="onUpsertPermission()">
    <div class="container-fluid p-0">
      <mat-card>
        <div class="row">
          <div class="col-md-6 form-group">
            <app-input-template
              [inputData]="attrConstant.name"
              [formControlName]="attrConstant.name.key"></app-input-template>
          </div>
          <div class="col-md-6 form-group">
            <app-input-template
              [inputData]="attrConstant.description"
              [formControlName]="
                attrConstant.description.key
              "></app-input-template>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 form-group">
            <app-input-template
              [inputData]="attrConstant.selectionOrder"
              [formControlName]="
                attrConstant.selectionOrder.key
              "></app-input-template>
          </div>
          <div class="col-md-6 form-group">
            <mat-checkbox [formControlName]="attrConstant.isCollapsible.key">
              Is Collapsable
            </mat-checkbox>
            <mat-checkbox
              [formControlName]="attrConstant.isActive.key"
              class="ms-3">
              Active
            </mat-checkbox>
          </div>
        </div>
      </mat-card>
      <mat-card formArrayName="permissions" class="my-3 mx-0">
        <mat-card-title class="h4">Permission Data</mat-card-title>
        <mat-divider class="position-relative mb-3"></mat-divider>
        <div *ngFor="let Permission of permissionData.controls; let i = index">
          <mat-divider
            *ngIf="permissionData.controls.length > 1 && i > 0"
            class="position-relative my-3"></mat-divider>
          <div [formGroupName]="i">
            <div class="row">
              <div class="col-md-4 form-group">
                <app-input-template
                  [inputData]="attrConstant.permData.title"
                  [formControlName]="
                    attrConstant.permData.title.key
                  "></app-input-template>
              </div>
              <div class="col-md-4 form-group">
                <app-input-template
                  [inputData]="attrConstant.permData.slug"
                  [formControlName]="
                    attrConstant.permData.slug.key
                  "></app-input-template>
              </div>
              <div class="col-md-4 form-group">
                <app-input-select
                  [inputData]="attrConstant.permData.permissionType"
                  [selectOptions]="permissionType"
                  [bindLabel]="'name'"
                  [bindValue]="'value'"
                  [formControlName]="
                    attrConstant.permData.permissionType.key
                  "></app-input-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 form-group">
                <app-input-template
                  [inputData]="attrConstant.permData.description"
                  [formControlName]="
                    attrConstant.permData.description.key
                  "></app-input-template>
              </div>
              <div class="col-md-4 form-group">
                <app-input-template
                  [inputData]="attrConstant.permData.apiEndpoint"
                  [formControlName]="
                    attrConstant.permData.apiEndpoint.key
                  "></app-input-template>
              </div>
              <div class="col-md-3 form-group">
                <mat-checkbox
                  [formControlName]="attrConstant.permData.displayInMenu.key">
                  In Menu
                </mat-checkbox>
                <mat-checkbox
                  [formControlName]="attrConstant.permData.isActive.key"
                  class="ms-3">
                  Active
                </mat-checkbox>
              </div>
              <div
                class="col-md-1 text-end ps-0"
                *ngIf="permissionData.controls.length > 1">
                <a
                  (click)="removePermissionRow(i)"
                  mat-stroked-button
                  color="warn"
                  class="dlt-btn border-0"
                  [attr.aria-hidden]="true">
                  <mat-icon class="m-0">delete forever</mat-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
        <mat-divider class="mt-3"></mat-divider>
        <mat-card-actions class="row mt-3 d-flex justify-content-end">
          <div class="col-md-3 text-end">
            <a
              mat-stroked-button
              class="ubx-primary"
              [attr.aria-hidden]="true"
              (click)="addPermissionRow()">
              + Add New Permission
            </a>
          </div>
        </mat-card-actions>
      </mat-card>
      <div class="btn-group">
        <button mat-raised-button>
          <ng-container *ngIf="!isEdit">Add</ng-container>
          <ng-container *ngIf="isEdit">Update</ng-container> Permission
        </button>
        <a routerLink="['/user-management/permission/list']" mat-raised-button>
          Cancel
        </a>
      </div>
    </div>
  </form>
</div>
